import type { OktaUser } from '@sportybot-web/auth/context';

import { Avatar, Group, Stack, Text } from '@mantine/core';

export interface UserInfoProps {
  emailVariant: 'body-0' | 'body-1';
  fullNameVariant: 'body-0-emphasis' | 'body-1-emphasis';
  user: OktaUser;
}

export function UserInfo({ emailVariant, fullNameVariant, user }: UserInfoProps) {
  const { email, firstName, lastName } = user;
  const fullName = `${firstName} ${lastName}`;

  return (
    <Group gap="space100">
      <Avatar color="blue" name={fullName} radius="radius-max" variant="filled" />
      <Stack gap="space0" w={210}>
        <Text truncate variant={fullNameVariant}>
          {fullName}
        </Text>
        <Text c="dimmed" truncate variant={emailVariant}>
          {email}
        </Text>
      </Stack>
    </Group>
  );
}
